import { JobType } from "../enums/JobType"
import { LocationType } from "../enums/LocationType"
import { SeniorityLevel } from "../enums/SeniorityLevel"
import { VacancyStatus } from "../enums/VacancyStatus"
import { WeightedSkill } from "../entities/WeightedSkill"
import { Department } from "../enums/Department"
import { ExternalPosting } from "./VacancyListItemDto"
import { SageOriginMetadataDto } from "../infrastructure/sage300-service"

export enum VacancyOrigin {
    Internal = 0,
    Sage300People = 1,
}

export interface VacancyDto {
    yearsOfExperience: number
    applicationCount: number
    id: string
    title: string
    description: string
    department: Department
    locationType: LocationType
    jobType: JobType
    minimumSalary: number
    maximumSalary: number
    organizationId: string
    applicationDeadline: string
    currency?:string
    baseScore: number
    keyResponsibilities: WeightedSkill[]
    requiredSkills: WeightedSkill[]
    optionalSkills: WeightedSkill[]
    educationLevel?: string | null
    certifications: WeightedSkill[]
    seniorityLevel: SeniorityLevel
    status: VacancyStatus
    createdAt: string
    updatedAt: string
    postedDate?: string
    externalPostings?: ExternalPosting[]
    origin?: VacancyOrigin
    sageMetadata?: SageOriginMetadataDto | null
}